var _g, _path, _path2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrows = function SvgArrows(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 24,
    height: 24,
    rx: 5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4644 21.4601L28.0764 20.7521C28.3164 20.4761 28.6644 20.3081 29.0364 20.3081H33.0804L32.8164 21.6161C32.7444 21.9521 33.1284 22.1921 33.4044 21.9881L36.7884 19.4801C36.9924 19.3361 36.9924 19.0361 36.7884 18.8801L33.4044 16.3721C33.1284 16.1681 32.7444 16.4081 32.8164 16.7441L33.0804 18.0521H28.9644C27.9204 18.0521 27.0684 18.9041 27.0684 19.9481V21.3041C27.0684 21.5201 27.3324 21.6161 27.4644 21.4601Z",
    fill: "#9595B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5356 22.5397L35.9236 23.2477C35.6836 23.5237 35.3356 23.6917 34.9636 23.6917H30.9196L31.1836 22.3837C31.2556 22.0477 30.8716 21.8077 30.5956 22.0117L27.2116 24.5197C27.0076 24.6637 27.0076 24.9637 27.2116 25.1197L30.5836 27.6277C30.8596 27.8317 31.2436 27.5917 31.1716 27.2557L30.9196 25.9477H35.0356C36.0796 25.9477 36.9316 25.0957 36.9316 24.0517V22.6957C36.9316 22.4797 36.6676 22.3837 36.5356 22.5397Z",
    fill: "#9595B1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrows, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrows.85d028f9.svg";
export { ForwardRef as ReactComponent };